(function () {
    'use strict';

    angular
        .module('app.widgets')
        .directive('obtMenu', obtMenu)
        .directive('obtMenuXs', obtMenuXs);

    function obtMenu () {
        return  {
            controller:menuController,
            controllerAs:'vmMenu',
            scope:{
                data:'='
            },
            bindToController:true,
            replace:true,
            template:'<li class="hidden-xs dropdown tasks-menu">\n    <a href="javascript:void(0)" class="dropdown-toggle" data-toggle="dropdown">\n        <i class="fa fa-bars"></i>\n    </a>\n    <ul class="dropdown-menu">\n        <li>\n            <ul class="menu" style="max-height: 600px;">\n                <li ng-repeat="menu in vmMenu.data | orderBy:\'order\'" ng-switch="menu.type">\n                    \n                    <a ng-switch-when="1" href="javascript:void(0)" ng-click="vmMenu.gotoAnchor(menu.data.link)">\n                        <!--anchor-->\n                        <h3>{{menu.data.name}}</h3>\n                    </a>\n                    <a ng-switch-when="2" href="javascript:void(0)" ui-sref="{{menu.data.link}}">\n                        <!--internal link-->\n                        <h3>{{menu.data.name}}</h3>\n                    </a>\n                    <a ng-switch-when="3" href="{{menu.data.link}}">\n                        <!--external link-->\n                        <h3>{{menu.data.name}}</h3>\n                    </a>\n                </li>\n            </ul>\n        </li>\n    </ul>\n</li>      ',
          restrict: 'AE'
        };
    }

    function obtMenuXs () {
        return  {
            controller:menuController,
            controllerAs:'vmMenu',
            scope:{
                data:'='
            },
            bindToController:true,
            replace:true,
            templateUrl:'app/widgets/obtMenu.html',
            // template:'<li class="visible-xs-block" ng-repeat="menu in vmMenu.data | orderBy:\'order\'" ng-switch="menu.type">\n    \n    <a ng-switch-when="1" href="javascript:void(0)" ng-click="vmMenu.gotoAnchor(menu.data.link)">\n        <!--anchor-->\n        {{menu.data.name}}\n    </a>\n    <a ng-switch-when="2" href="javascript:void(0)" ui-sref="{{menu.data.link}}">\n        <!--internal link-->\n        {{menu.data.name}}\n    </a>\n    <a ng-switch-when="3" href="{{menu.data.link}}">\n        <!--external link-->\n        {{menu.data.name}}\n    </a>\n</li>',
            restrict: 'AE'
        };
    }


    /*@ngInject*/
    function menuController($stateParams, config, $location, $anchorScroll){

       console.log('la c bon');
        var vm = this;
        vm.data = vm.data;
        vm.selectedMenuId = $stateParams.menu || config.menu;//obtSession.get('menu');
        vm.gotoAnchor = gotoAnchor;
        vm.test = function(data){
          console.log(data);
        }
        active(); //fill the combobox

        // function goTo (key){
        //     console.debug('Go to : ' , key);
        // }
        function gotoAnchor(x) {
            var newHash = 'anchor' + x;
            if ($location.hash() !== newHash) {
                // set the $location.hash to `newHash` and
                // $anchorScroll will automatically scroll to it
                $location.hash('anchor' + x);
            } else {
                // call $anchorScroll() explicitly,
                // since $location.hash hasn't changed
                $anchorScroll();
            }
        }

        function active(){
            var args = {cId:vm.cid || null, tId:vm.tid || null };
            // menuServices.getMenusPromise(args)
            //     .then(function(result){
            //             vm.data = result;
            //         }
            //     );
        }
    }
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/obt-menu.directive.js
 ** module id = 194
 ** module chunks = 0
 **/